export default __webpack_public_path__ + "static/media/cd.3ff54c67.mp3";